import { Button as BaseButton } from 'antd';
import { lang } from 'zf-infra';
import { convert } from 'zf-web-components/icons';
import type { ReactElement } from 'react';
import type { ButtonProps } from './types';

export function Button(props: ButtonProps): ReactElement {
  const { label, type = 'default', onClick, icon } = props;

  return (
    <BaseButton
      {...props}
      type={type}
      icon={convert(icon)}
      onClick={lang.debounce(event => onClick?.(event), 300)}
    >
      {label}
    </BaseButton>
  );
}
